// extracted by mini-css-extract-plugin
export var cartContainer = "_fl-4";
export var gray = "_fl-1";
export var itemContainer = "_fl-2";
export var itemDetails = "_fl-3";
export var strong = "_fl-0";